import axios from 'axios';

import routes from 'app/routes';

export default {
  skip: (type, callback) => {
    axios
      .post(routes.api.required_actions.skip, {
        type,
      })
      .then((_resp) => {
        callback();
      });
  },
};
